import styled from "@emotion/styled";

export const StyledBox = styled.div`
  background-color: white;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  padding: 1.2rem 2rem;
  min-width: 300px;
  flex: 1 1 300px;
  width: 0;
`;

export const StyledUSP = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
`;

export const StyledBoxContainer = styled.div`
  flex: 1 1 300px;
`;

export const ScrollableContainer = styled.div`
  overflow-x: auto;
  padding: 0 1rem 1rem 1rem;
`;
